var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isDesktop
    ? _c(
        "div",
        {
          staticClass:
            "adv-item rating position-relative h-100 d-inline-block float-left mr-4",
          on: { mouseleave: _vm.hideRatingWithDelay },
        },
        [
          _c(
            "span",
            {
              staticClass: "position-relative",
              on: {
                mouseover: function ($event) {
                  _vm.fetchRating()
                  _vm.showRating = true
                },
              },
            },
            [
              _c("StarRating", {
                attrs: {
                  inline: true,
                  rating: _vm.ratingForStarsComp,
                  "read-only": true,
                  increment: 0.01,
                  "show-rating": false,
                  "max-rating": 5,
                },
              }),
              _vm._v(
                "\n    " +
                  _vm._s(_vm.starsRating) +
                  " / 5,0\n    " +
                  _vm._s(
                    _vm.$translate(
                      "maversandVuePlugin::Additional.topbarRatingStars"
                    )
                  ) +
                  "\n\n    "
              ),
              _c("sup", [
                _c(
                  "a",
                  {
                    staticClass: "text-dark",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.scrollToDisclaimer.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("1")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.scoreCount !== null && _vm.showRating,
                      expression: "scoreCount !== null && showRating",
                    },
                  ],
                  staticClass: "dropdown-menu",
                  staticStyle: {
                    display: "block",
                    position: "absolute",
                    "z-index": "1000",
                  },
                  on: {
                    mouseover: function ($event) {
                      _vm.isMouseOverDropdown = true
                    },
                    mouseleave: function ($event) {
                      _vm.isMouseOverDropdown = false
                    },
                  },
                },
                [
                  _vm._l(_vm.criteriaName, function (name, key) {
                    return _c(
                      "div",
                      { key: key, staticClass: "rating-container" },
                      [
                        _c("div", { staticClass: "rating-name" }, [
                          _vm._v(_vm._s(name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "stars" }, [
                          _c(
                            "div",
                            {
                              staticClass: "filled-stars",
                              style: {
                                width: (_vm.criteriaValue[key] / 5) * 100 + "%",
                              },
                            },
                            _vm._l(5, function (n) {
                              return _c(
                                "svg",
                                {
                                  key: n,
                                  staticClass: "star",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "#000000",
                                    "stroke-width": "1",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("polygon", {
                                    attrs: {
                                      points:
                                        "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
                                    },
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "empty-stars" },
                            _vm._l(5, function (n) {
                              return _c(
                                "svg",
                                {
                                  key: n,
                                  staticClass: "star",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "#000000",
                                    "stroke-width": "1",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("polygon", {
                                    attrs: {
                                      points:
                                        "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
                                    },
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "criteria-rating" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.criteriaValue[key]) +
                              "\n        "
                          ),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "owl-carousel rating-carousel owl-theme",
                      staticStyle: { "max-width": "30em" },
                    },
                    _vm._l(_vm.latestReview, function (review, index) {
                      return _c("div", { key: index }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item review-text",
                            attrs: {
                              href: "https://www.shopvote.de/bewertung_ma_versand_de_9786.html",
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "#000000",
                                  "stroke-width": "1",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M5.52 19c.64-2.2 1.84-3 3.22-3h6.52c1.38 0 2.58.8 3.22 3",
                                  },
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: { cx: "12", cy: "10", r: "3" },
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: { cx: "12", cy: "12", r: "10" },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.truncatedReviews[index])
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }